import React, { FC, memo } from "react";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { Header } from "../Header";
import { ButtonIconPlaceholder } from "../buttonIconPlaceholder/ButtonIconPlaceholder";

interface OrdersHeaderProps {
  readonly onBack: () => void;
}

const OrdersHeader: FC<OrdersHeaderProps> = ({ onBack }) => {
  const ordersHeaderText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.ORDERS_HEADER,
  });

  return (
    <Header testID="orders-header">
      <ButtonIcon name="arrow_left" testID="arrow-left-button-icon" onPress={onBack} />
      <Text ellipsizeMode="tail" level={3} numberOfLines={1} style={{ flexShrink: 1 }} variant="action">
        {ordersHeaderText}
      </Text>
      <ButtonIconPlaceholder />
    </Header>
  );
};

const MemoizedOrdersHeader = memo(OrdersHeader);

export { MemoizedOrdersHeader as OrdersHeader };
